<script setup lang="ts">

import { DataRow } from "@hantera/design-system";
import { computed, inject, ref } from "vue";
import { legacyModeKey } from "@hantera/portal-app";

const props = defineProps<{
  row?: DataRow
  selection?: unknown
}>()

const legacyMode = inject(legacyModeKey, false)

// Use the persisted selection as the source of truth so the detail survives
// search/refresh even when the selected row is not on the loaded page.
// The key is `deliveryId@orderId`; we navigate to the order.
const key = computed(() =>
  props.row?.key ?? (props.selection != null ? String(props.selection) : undefined)
)

const uri = computed(() => {
  if (!key.value) {
    return undefined
  }
  const orderId = key.value.split('@')[1]
  return (legacyMode ? '/legacy-order' : '/order') + '?id=' + orderId
})

const state = ref<Record<string, any>>({
  selectedTab: 'deliveries'
})

</script>

<template>
  <EmbeddedView
    v-if="uri"
    :uri="uri"
    :state="state"
  />
</template>

<style scoped></style>
